module.exports = __webpack_public_path__ + "static/img/xunyu.6080c696.png";